import { Content } from "@/ui/Content";
import { Collection } from "@sourceflow-uk/sourceflow-sdk";
import { getTeam } from "@/functions/getTeam";
import * as additionalComponents from "@/components/TeamMemberPage";
import { stripTags } from "@/functions/stripTags";
import { parseRoute } from "@/functions/parseRoute";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const item = getTeam().find((i) => i.url_slug === url_slug);

  const routerKey = "team.member";
  const routerProp = parseRoute(routerKey, { url_slug });

  return {
    props: {
      meta: {
        en: {
          title: stripTags(item.name),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
          description: `Talk with Gravitas's ${item.name} to discuss the job opportunity you are interested in or find out about the latest jobs.`,
        },
      },
      router: routerProp,
      content: [
        { component: "TeamMemberPageBannerSection", props: { className: "", item } },
        { component: "TeamMemberPageContentSection", props: { className: "pt-5", item } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: (await Collection("team")).getPaths("url_slug"),
    fallback: false,
  };
}
